import { render } from "./index.vue?vue&type=template&id=44c84e76"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baikaifa/Library/Containers/com.tencent.xinWeChat/Data/Documents/xwechat_files/wxid_1rhhjrwiu7uq22_9030/msg/file/2026-08/ubang-copilot-agents-web-deploy-2026-08-31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__